export const RoutePostCategories = "/categories";

export const RoutePutCategories = RoutePostCategories;

export interface PayloadPostCategories {
  categoryGroup: string;
  categoryCode: string;
}

export interface PayloadPutCategories {
  categoryId: number;
  categoryGroup: string;
  categoryCode: string;
}

export interface ResponsePostCategories {
  id: number;
  code: string;
  status: "ACTIVE" | "ARCHIVED";
  created_at: string;
  updated_at: string;
  category_group: string;
}

export type ResponsePutCategories = ResponsePostCategories;

export const RouteGetCategories = "/categories";

export interface QueryParamsGetCategories {
  includeArchived?: string;
}

export type ResponseGetCategories = {
  categoryGroup: string;
  categories: Category[];
}[];

export interface Category {
  id: number;
  code: string;
  status: "ACTIVE" | "ARCHIVED";
  categoryGroup: string;
  isBound: boolean;
}
